import React, { useEffect, useMemo } from "react";
import Stories from "react-insta-stories";
import { S3_MENU_FOLDER } from "../../store/constants";
import CuiratoLogoTransparent from "../../assets/CuiratoLogoTransparent.png";
import ExploreStoryLanding from "../../assets/ExploreStoryLanding.png";
import ExploreStoryLanding1 from "../../assets/ExploreStoryLanding1.png";
import ExploreStoryLanding2 from "../../assets/ExploreStoryLanding2.png";
import ExploreStoryLanding3 from "../../assets/ExploreStoryLanding3.png";
import ExploreStoryLanding4 from "../../assets/ExploreStoryLanding4.png";
import Bookmark from "../../assets/Bookmark.png";
import Share from "../../assets/Share.png";
// import ReactInstaStories from "../InstaStoriesPackage/index.tsx";

const getResponsiveGap = () => {
  const screenHeight = window.innerHeight;

  const minHeight = 659;
  const maxHeight = 809;
  const minGap = 20;
  const maxGap = 40;

  if (screenHeight <= minHeight) return minGap;
  if (screenHeight >= maxHeight) return maxGap;

  const ratio = (screenHeight - minHeight) / (maxHeight - minHeight);
  return minGap + ratio * (maxGap - minGap);
};

const gap = getResponsiveGap();

export const LandingStory11 = ({ handleCancel, action, index, activeIndex }) => {

  return (
    <div
      // className="recommendationModal"
      title="Find your favourite soup"
    >
      {/* <img
        style={{
          height: "100%",
          objectFit: "cover",
          position: "absolute",
          top: 0,
        }}
        src={ExploreStoryLanding1}
      /> */}
      <div className="exploreStoryLandingBg" />
      <div
        // className={classNames("swipableCardsWrapper")}
        style={{
          paddingTop: gap,
          position: "absolute",
          top: 0,
          width: "100%",
        }}
      >
        <div className="swipableCardsContainer">
          <div className="tinderCardsContainer">
            <div
              style={{ rowGap: gap }}
              className="tinderMainThumbImageWrapper"
            >
              <div className="landingAnimationTopWrapper Satoshi">
                <div></div>

                {/* <div class="chat-bubble-wrapper">
                  <div class="chat-bubble">
                    <img src={ExploreStoryLanding1} alt="Chef" />
                  </div>
                  <div class="chat-tail"></div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        style={{ padding: "0px 40px 65px 40px" }}
        className="tinderSwipeButtonsMainThumb"
      >
        <div className="landingPageDescHeader">
          Amit left his advertising job. He wanted to cook.
        </div>
        <div className="landingPageDesc">
          So he did. 4 years as a home cook. Fed friends.Then the community -{" "}
          <span className="landingPageDescBold">
            6 years as a chef entrepreneur in Lokhandwala.
          </span>
        </div>
        <div className="charsi-banner-wrapper">
          {/* <div className="charsi-banner" onClick={() => handleCancel()}>
            <span className="charsi-text">Get his Charsi Mutton now.</span>
          </div> */}
          {/* <div className="charsi-icons">
            <img style={{ height: 20 }} src={Bookmark} />
            <img style={{ height: 20 }} src={Share} />
          </div> */}
        </div>
        <div
        style={{ padding: "0px 40px 20px 40px" }}
        className="tinderSwipeButtonsMainThumb"
      >
        <div style={{ marginBottom: 5, marginTop: 0 }} className="landingPageTapLabelWrapper">
          <span className="landingPageTapLabel">Tap to know more</span>
        </div>
      </div>
      </div>
    </div>
  );
};
export const LandingStory12 = ({ handleCancel, action, index, activeIndex, handleNextSlide }) => {

  return (
    <div
      // className="recommendationModal"
      title="Find your favourite soup"
    >
      {/* <img
        style={{
          height: "100%",
          objectFit: "cover",
          position: "absolute",
          top: 0,
        }}
        src={ExploreStoryLanding2}
      /> */}
      <div className="exploreStoryLandingBg" />
      <div
        // className={classNames("swipableCardsWrapper")}
        style={{
          paddingTop: gap,
          position: "absolute",
          top: 0,
          width: "100%",
        }}
      >
        <div className="swipableCardsContainer">
          <div className="tinderCardsContainer">
            <div
              style={{ rowGap: gap }}
              className="tinderMainThumbImageWrapper"
            >
              <div className="landingAnimationTopWrapper Satoshi">
                <div></div>

                {/* <div class="chat-bubble-wrapper">
                  <div class="chat-bubble">
                    <img src={ExploreStoryLanding2} alt="Chef" />
                  </div>
                  <div class="chat-tail"></div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="tinderSwipeBottomShadow"></div> */}
      <div
        style={{ padding: "0px 40px 65px 40px" }}
        className="tinderSwipeButtonsMainThumb"
      >
        <div className="landingPageDescHeader">Zaffar makes Biryani.</div>
        <div className="landingPageDesc">
          His cousin was good at Math - Accountant. His sister, a nerd -
          Dentist.{" "}<br></br>
          <span className="landingPageDescBold">Zaffar makes Biryani.</span>
        </div>
        <div className="charsi-banner-wrapper">
          <div className="charsi-banner" onClick={() => handleNextSlide()}>
            <span className="charsi-text">Get Rozana Biryani @ ₹150</span>
          </div>
          {/* <div className="charsi-icons">
            <img style={{ height: 20 }} src={Bookmark} />
            <img style={{ height: 20 }} src={Share} />
          </div> */}
        </div>
      </div>
    </div>
  );
};
export const LandingStory13 = ({ handleCancel, action, index, activeIndex }) => {


  return (
    <div
      // className="recommendationModal"
      title="Find your favourite soup"
    >
      {/* <img
        style={{
          height: "100%",
          objectFit: "cover",
          position: "absolute",
          top: 0,
        }}
        src={ExploreStoryLanding3}
      /> */}
      <div className="exploreStoryLandingBg" />
      <div
        // className={classNames("swipableCardsWrapper")}
        style={{
          paddingTop: gap,
          position: "absolute",
          top: 0,
          width: "100%",
        }}
      >
        <div className="swipableCardsContainer">
          <div className="tinderCardsContainer">
            <div
              style={{ rowGap: gap }}
              className="tinderMainThumbImageWrapper"
            >
              <div className="landingAnimationTopWrapper Satoshi">
                <div></div>

                {/* <div class="chat-bubble-wrapper">
                  <div class="chat-bubble">
                    <img src={ExploreStoryLanding3} alt="Chef" />
                  </div>
                  <div class="chat-tail"></div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
       {/* <div className="tinderSwipeBottomShadow"></div> */}
      <div
        style={{ padding: "0px 40px 65px 40px" }}
        className="tinderSwipeButtonsMainThumb"
      >
        <div className="landingPageDescHeader">
          Ruth cooked an omelette before she could write.
        </div>
        <div className="landingPageDesc">
          Studied culinary at IHM, interned at ITC Maratha Marriott, Peninsula
          under her belt.{" "}
          <span className="landingPageDescBold">Makes a mean B.L.T.</span>
        </div>
        <div className="charsi-banner-wrapper">
          <div className="charsi-banner" onClick={() => handleCancel()}>
            <span className="charsi-text">
              Order Continental from Ruth in Bandra
            </span>
          </div>
          {/* <div className="charsi-icons">
            <img style={{ height: 20 }} src={Bookmark} />
            <img style={{ height: 20 }} src={Share} />
          </div> */}
        </div>
      </div>
    </div>
  );
};
export const LandingStory14 = ({ handleCancel, action, index, activeIndex }) => {


  return (
    <div
      // className="recommendationModal"
      title="Find your favourite soup"
    >
      {/* <img
        style={{
          height: "100%",
          objectFit: "cover",
          position: "absolute",
          top: 0,
        }}
        src={ExploreStoryLanding4}
      /> */}
      <div className="exploreStoryLandingBg" />
      <div
        // className={classNames("swipableCardsWrapper")}
        style={{
          paddingTop: gap,
          position: "absolute",
          top: 0,
          width: "100%",
        }}
      >
        <div className="swipableCardsContainer">
          <div className="tinderCardsContainer">
            <div
              style={{ rowGap: gap }}
              className="tinderMainThumbImageWrapper"
            >
              <div className="landingAnimationTopWrapper Satoshi">
                <div></div>

                {/* <div class="chat-bubble-wrapper">
                  <div class="chat-bubble">
                    <img src={ExploreStoryLanding4} alt="Chef" />
                  </div>
                  <div class="chat-tail"></div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
       {/* <div className="tinderSwipeBottomShadow"></div> */}
      <div
        style={{ padding: "0px 40px 65px 40px" }}
        className="tinderSwipeButtonsMainThumb"
      >
        <div className="landingPageDescHeader">
          Punit acts. You’ll see him as a star on Star.
        </div>
        <div className="landingPageDesc">
          In person?{" "}
          <span className="landingPageDescBold">
            Meet him at his restaurant
          </span>
          - his passion project. Serving Kulchas like it’s Amritsar.
          {/* <span className="landingPageDescBold">A true Punjabi.</span> */}
        </div>
        <div className="charsi-banner-wrapper">
          <div className="charsi-banner" onClick={() => handleCancel()}>
            <span className="charsi-text">Dine in with Punit.</span>
          </div>
          {/* <div className="charsi-icons">
            <img style={{ height: 20 }} src={Bookmark} />
            <img style={{ height: 20 }} src={Share} />
          </div> */}
        </div>
      </div>
    </div>
  );
};

// const LandingPage = ({
//   handleCancel,
//   index,
//   activeIndex,
//   setShowLocationModal,
// }) => {
//   const stories = useMemo(
//     () => [
//       {
//         url: "",
//         content: ({ action, isPaused }) => {
//           return (
//             <Content2
//               handleCancel={handleCancel}
//               action={action}
//               index={index}
//               activeIndex={activeIndex}
//             />
//           );
//         },
//       },
//       {
//         url: "",
//         content: ({ action, isPaused }) => {
//           return (
//             <Content3
//               handleCancel={handleCancel}
//               action={action}
//               index={index}
//               activeIndex={activeIndex}
//             />
//           );
//         },
//       },
//       {
//         url: "",
//         content: ({ action, isPaused }) => {
//           return (
//             <Content4
//               handleCancel={handleCancel}
//               action={action}
//               index={index}
//               activeIndex={activeIndex}
//             />
//           );
//         },
//       },
//       {
//         url: "",
//         content: ({ action, isPaused }) => {
//           return (
//             <Content5
//               handleCancel={handleCancel}
//               action={action}
//               index={index}
//               activeIndex={activeIndex}
//             />
//           );
//         },
//       },
//     ],
//     [handleCancel, index, activeIndex]
//   );

//   const onAllStoriesEnd = () => {
//     handleCancel();
//   };

//   return (
//     <Stories
//       key={index}
//       onAllStoriesEnd={onAllStoriesEnd}
//       defaultInterval={5000}
//       width="100%"
//       height="100dvh"
//       stories={stories}
//       isPaused={true}
//       instaIndex={index}
//       loop
//     />
//   );
// };

// export default LandingPage;
